@file:OptIn(ExperimentalBlockRichTextApi::class)

package com.taocent.simple.compose.component.blockrichtext.internal.block.renderer

import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.offset
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.IntOffset
import androidx.compose.ui.zIndex
import com.taocent.simple.compose.component.blockrichtext.ExperimentalBlockRichTextApi
import kotlin.math.roundToInt

/**
 * 独立的列按钮 Composable,隔离列按钮的重组范围。
 * 抽离自 `TableRenderer.kt`,通过参数接收所有需要的输入。
 */
@Composable
internal fun TableColumnButton(
    menuButtonSize: Dp,
    columnWidthDp: Dp,
    colOffset: Float,
    isColLifted: Boolean,
    showColumnButton: Boolean,
    isSelectedCol: Boolean,
    showColumnMenu: Boolean,
    colDragGestureModifier: Modifier,
    onColumnClick: () -> Unit,
    onInsertLeft: () -> Unit,
    onInsertRight: () -> Unit,
    onDeleteColumn: () -> Unit,
    onDismissMenu: () -> Unit,
) {
    Box(
        modifier = Modifier
            .zIndex(if (isColLifted) 1f else 0f)
            .width(columnWidthDp)
            .offset { IntOffset(colOffset.roundToInt(), 0) }
            .then(if (showColumnButton) colDragGestureModifier else Modifier),
        contentAlignment = Alignment.Center
    ) {
        if (showColumnButton) {
            ThreeDotsButton(
                horizontal = true,
                modifier = Modifier.size(menuButtonSize),
                onClick = onColumnClick
            )
            ColumnMenu(
                expanded = showColumnMenu && isSelectedCol,
                onDismiss = onDismissMenu,
                onInsertLeft = onInsertLeft,
                onInsertRight = onInsertRight,
                onDelete = onDeleteColumn
            )
        } else {
            Spacer(modifier = Modifier.height(menuButtonSize))
        }
    }
}
